import React from 'react'
import { BiometryType } from 'capacitor-native-biometric'
import type { NumpadProps } from 'redesign/components/organisms/numpad/types'
import NumpadInputButton from '../numpad-input-button'
import NumpadInputFaceIdButton from '../numpad-input-face-id-button'
import NumpadInputTouchIdButton from '../numpad-input-touch-id-button/numpad-input-touch-id-button'
import { useNumpadInputBiometric } from './use-numpad-input-biometric'

const NumpadInputBiometricButton: React.FC<Pick<NumpadProps, 'setNumpadValue'>> = ({ setNumpadValue }) => {
  const { handleKeychainPin, biometricTypeAvailable, displayButton } = useNumpadInputBiometric({ setNumpadValue })

  if (!displayButton) return <NumpadInputButton onClick={() => {}} />

  switch (biometricTypeAvailable) {
    case BiometryType.TOUCH_ID:
    case BiometryType.FINGERPRINT: {
      return <NumpadInputTouchIdButton handleKeychainPin={handleKeychainPin} />
    }
    default:
      return <NumpadInputFaceIdButton handleKeychainPin={handleKeychainPin} />
  }
}

export default NumpadInputBiometricButton
